import { TFunction } from 'i18next';

export enum WfPriority {
  None = 0,
  Low = 1,
  Medium = 2,
  High = 3,
  Other = 4,
  Blank = 5,
}

export const WfPriorityStatusMapping = (t: TFunction) => ({
  [WfPriority.None]: {
    title: t('wf.statusInformationRegistration.priorityOptions.none'),
    value: WfPriority.None,
  },
  [WfPriority.Low]: {
    title: t('wf.statusInformationRegistration.priorityOptions.low'),
    value: WfPriority.Low,
  },
  [WfPriority.Medium]: {
    title: t('wf.statusInformationRegistration.priorityOptions.medium'),
    value: WfPriority.Medium,
  },
  [WfPriority.High]: {
    title: t('wf.statusInformationRegistration.priorityOptions.high'),
    value: WfPriority.High,
  },
  [WfPriority.Other]: {
    title: t('wf.statusInformationRegistration.priorityOptions.other'),
    value: WfPriority.Other,
  },
  [WfPriority.Blank]: {
    title: '',
    value: WfPriority.Blank,
  },
});

export const getPriorityOptions = (t: TFunction) => Object.values(WfPriorityStatusMapping(t));
